import { render, staticRenderFns } from "./redpack.vue?vue&type=template&id=a3c36be6&scoped=true&"
import script from "./redpack.vue?vue&type=script&lang=js&"
export * from "./redpack.vue?vue&type=script&lang=js&"
import style0 from "./redpack.vue?vue&type=style&index=0&id=a3c36be6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c36be6",
  null
  
)

export default component.exports